import React, { useState } from 'react'
import Icon from '../../../blocks.simple/icon/icon'
import styles from './selectFromFile.jcss'
import translate from '../../../core/translate'
import { WikiInfo } from 'blocks.simple/wikiInfo/WikiInfo'
import Uploader from '../../uploader'
import { ItemData } from '../../../core/models/Template'

export const SelectFromFile = ({
    onSelectFromFile,
    selectedItems,
    type,
}: {
    onSelectFromFile: (file: any) => void
    selectedItems: ItemData[]
    type: string
}) => {
    const [showUploader, setShowUploader] = useState<boolean>(false)

    const onDataReceived = (res: any) => {
        if (!res && !res.body && !res.body.data) return

        const data = res.body.data

        onSelectFromFile({ selected: data.selected, notSelected: data.notSelected })
        setShowUploader(false)
    }

    const renderUploader = () => {
        return (
            <div className={styles.uploaderWrapper}>
                <Uploader
                    uploadMethod={'getSelectionByFile'}
                    isModal={false}
                    showCloseButton={true}
                    onClose={() => setShowUploader(false)}
                    onResponse={onDataReceived}
                    isSelectFromFile={true}
                    selectedItems={selectedItems}
                />
            </div>
        )
    }

    return (
        <>
            {showUploader && renderUploader()}
            <div className={styles.selectorWrapper} onClick={() => setShowUploader(true)}>
                <>
                    <Icon type="file" default={true} />
                    <span className={styles.fileUploadLabel}>{translate('selectFromFile')}</span>
                    <WikiInfo
                        blockKey={'broadcast'}
                        blockSubKey={'createBroadcast'}
                        infoKey={'broadcastFromFileUpload'}
                    />
                </>
            </div>
        </>
    )
}
